export type RetailProperty = { id: string; name: string; options: string[] };
export type RetailPropertyAssignments = Record<
  string,
  Record<string, string[]>
>;

// Keep configured order, ignore removed options, and count each SKU once per value.
export function retailPropertyValues(
  skuId: number,
  property: RetailProperty,
  assignments?: RetailPropertyAssignments
): string[] {
  const selected = new Set(assignments?.[skuId]?.[property.id] ?? []);
  return [...new Set(property.options)].filter((value) => selected.has(value));
}
